import type { ExpectedUserBenefit } from '@openclassrooms/sdk-web';

import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

/* istanbul ignore next */
const { useUpdate: useUserExpectedBenefitsUpdate, useGet: useUserExpectedBenefits } = getCRUDHooks<
  ExpectedUserBenefit[]
>({
  entityName: 'userExpectedBenefits',
  update: (benefits, { userId }) =>
    clientApi.getOCClient().helpers.user.users.updateUserExpectedBenefits(userId, benefits),
  get: ({ userId }) => clientApi.getOCClient().helpers.user.users.getUserExpectedBenefits(userId),
});

export { useUserExpectedBenefitsUpdate, useUserExpectedBenefits };
